import { useAuthContext } from "./AuthProvider";

/**
 * Custom hook for auth operations. Must be used within AuthProvider.
 *
 * Provides:
 * - user, interactionStatus (MSAL InteractionStatus enum)
 * - Sign in and sign out (redirect flows)
 * - Access token acquisition for API calls
 * - Error state and clearError
 */
export function useAuth() {
  return useAuthContext();
}
